import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
} from '@mui/material';
import { Star } from '@mui/icons-material';
import theme from '../../theme/theme';

function Testimonials() {
  const testimonials = [
    {
      name: "Rohit Sharma",
      role: "Freelancer",
      content:
        "Working with SAINI COLLECTION was smooth and quick. They built my portfolio site exactly how I wanted. Great experience for a new freelancer like me.",
      rating: 5,
    },
    {
      name: "Priya Mehra",
      role: "Small Business Owner",
      content:
        "As a small business, we needed an affordable website. Their team delivered a beautiful site within budget and explained everything clearly.",
      rating: 5,
    },
    {
      name: "Ankit Verma",
      role: "Startup Founder",
      content:
        "Saini Collection helped us launch our startup website fast. Their design and support made it easy for us to get online and start growing.",
      rating: 5,
    },
  ];

  return (
    <Box
      id="testimonials"
      sx={{
        py: { xs: 6, md: 10 },
        background: "linear-gradient(to bottom, #f0f4f9, #e6f0ff)",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            textAlign: "center",
            maxWidth: 700,
            mx: "auto",
            mb: { xs: 4, md: 8 },
            px: { xs: 2, md: 0 },
          }}
        >
          <Typography
            variant="h3"
            gutterBottom
            sx={{
              color: theme.palette.primary.main,
              fontSize: { xs: "1.5rem", sm: "2.4rem", md: "3rem" },
              fontWeight: 700,
            }}
          >
            Voices of

            {" "}
            <Box component="span" sx={{ color: theme.palette.secondary.main }}>
              Our Clients
            </Box>
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: theme.palette.primary.light,
              maxWidth: 800,
              mx: "auto",
              mt: 1,
              px: { xs: 2, md: 0 },
              fontSize: { xs: "0.75rem", sm: "1rem", md: "1.125rem" }
            }}
          >
            Hear from people who trusted our work and saw results
          </Typography>
        </Box>

        <Grid container spacing={{ xs: 3, md: 4 }}>
          {testimonials.map((testimonial, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  border: `1px solid ${theme.palette.primary.light}`,
                  background: "#ffffff",
                }}
              >
                <CardContent
                  sx={{
                    p: { xs: 3, md: 4 },
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ display: "flex", mb: 2 }}>
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star
                        key={i}
                        sx={{ color: "#ffd700", fontSize: 20, mr: 0.5 }}
                      />
                    ))}
                  </Box>

                  <Typography
                    variant="body1"
                    component="div"
                    sx={{
                      color: theme.palette.primary.light,
                      maxWidth: 800,
                      mx: "auto",
                      mt: 1,
                      margin: { xs: "0 auto" , md: 0 },
                      px: { xs: 2, md: 0 },
                      fontSize: { xs: "0.75rem", sm: "1rem", md: "1.125rem" }
                    }}
                  >
                    "{testimonial.content}"
                  </Typography>
                </CardContent>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    p: { xs: 2.5, md: 3 },
                    borderTop: `1px solid ${theme.palette.primary.light}`,
                    background: "rgba(26, 58, 111, 0.05)",
                  }}
                >
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        fontSize: { xs: "1rem", sm: "1.125rem", md: "1.25rem" },
                        color: theme.palette.primary.main,
                        mr: 1,
                      }}
                    >
                      {testimonial.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: theme.palette.primary.light }}
                    >
                      {testimonial.role}
                    </Typography>
                  </Box>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default Testimonials;
